<h2 mat-dialog-title>
  <span class="filter-by-header">Filter by {{ filterName }}</span>

  <span class="action-button-container">
    <button
      class="button-icon"
      mat-icon-button
      aria-label="Actions"
      [matMenuTriggerFor]="actionsMenu"
      #menuTrigger="matMenuTrigger">
      <app-icon
        [svg]="EIcon.VERTICAL_DOTS"
        [iconColor]="EColorPalette.cGray5"
        [iconWidth]="24"
        [iconHeight]="24"></app-icon>
    </button>
    <mat-menu #actionsMenu="matMenu" class="menu-with-backdrop">
      <ng-template matMenuContent>
        <button mat-menu-item (click)="removeFilter()">Remove filter</button>
      </ng-template>
    </mat-menu>
  </span>
</h2>

<mat-dialog-content>
  <form class="w-100 display-flex flex-column grid-gap-4" [formGroup]="form">
    <div class="w-100 display-flex flex-column grid-gap-6">
      <div class="display-flex">
        <app-input
          class="w-100"
          [matFormCss]="'border-radius-partial-left'"
          formControlName="search"
          (keydownEnterEvent)="onSearch()"
          [attrPlaceholder]="
            form.get('searchBase')?.value === BaseType.Report
              ? 'Search across report’s data...'
              : 'Search across all (' + filterName + ')...'
          "></app-input>

        <button *ngIf="data.hideReportData" class="search-icon" mat-icon-button aria-label="Search">
          <app-icon
            [svg]="EIcon.ICON_SEARCH"
            [iconColor]="EColorPalette.cGray7"
            [iconWidth]="18"
            [iconHeight]="18"></app-icon>
        </button>

        <app-button-menu
          *ngIf="!data.hideReportData"
          [options]="baseOptions"
          [btnSearch]="true"
          [xPosition]="'before'"
          [isDisabledStroke]="true"
          [submitOnMainButtonClick]="true"
          (action)="onSearchBaseAction($event)"
          (submitAction)="onSearch()"></app-button-menu>
      </div>

      <div class="notification display-flex align-items-center grid-gap-6" *ngIf="!data.hideReportData">
        <div class="display-flex flex-column align-items-center justify-content-center content-warning-icon grid-gap-1">
          <div class="content-warning-icon-line"></div>
          <div class="content-warning-icon-dot"></div>
        </div>

        <ng-container *ngIf="form.get('searchBase')?.value === BaseType.Report">
          <span>
            Searching within report’s data. Click
            <a class="summary-filter-by-click summary-filter-by-click-action" (click)="toggleSearchBase()">
              all {{ filterName || '' }} values
            </a>
            to switch
          </span>
        </ng-container>
        <ng-container *ngIf="form.get('searchBase')?.value === BaseType.All">
          <span>
            Searching across all {{ filterName || '' }} values. Click
            <a class="summary-filter-by-click summary-filter-by-click-action" (click)="toggleSearchBase()">
              Report’s data
            </a>
            to switch
          </span>
        </ng-container>
      </div>

      <div class="slider-container">
        <app-slide-toggle
          [attrLeftLabel]="'Multi-choice'"
          [labelCss]="'body-small'"
          [attrRightLabel]="'Single-choice'"
          formControlName="isSingleChoice"
          [activeBold]="true"></app-slide-toggle>
      </div>
    </div>

    <ng-container *ngIf="!isLoading && filteredFilterByOptions?.length >= 0; else loading">
      <ng-container *ngIf="filteredFilterByOptions?.length > 0; else filterByOptionsEmpty">
        <!-- <ng-container *ngIf="isFormArrayAligned$ | async; else somethingWentWrong"> -->
        <div
          class="filter-by-options-container display-flex flex-column"
          [ngClass]="{ multiselect: isMultiselect }"
          formGroupName="filterValues">
          <ng-container *ngIf="filteredFilterByOptions?.length > 0 && isMultiselect">
            <mat-checkbox
              class="filter-by-label"
              color="primary"
              [checked]="allSelected"
              (change)="toggleAllOptions($event.checked)"
              [matTooltip]="'Includes hidden options!'"
              [matTooltipPosition]="'left'">
              <app-fade-text text="Select All"></app-fade-text>
            </mat-checkbox>

            <mat-divider></mat-divider>
          </ng-container>

          <ng-container *ngIf="isMultiselect">
            <div *ngFor="let option of filteredFilterByOptions; let i = index">
              <mat-checkbox class="filter-by-label" color="primary" [formControlName]="option.value.toString()">
                <app-fade-text [text]="option.label"></app-fade-text>
              </mat-checkbox>

              <mat-divider
                class="opt-divider"
                *ngIf="selectedDividerPosition === i && filteredFilterByOptions?.length > 2"></mat-divider>
            </div>
          </ng-container>

          <ng-container *ngIf="!isMultiselect">
            <ng-container *ngFor="let option of filteredFilterByOptions; let i = index">
              <div
                class="single-option"
                [ngClass]="{ active: option.value === selectedSingleChoiceOption }"
                (click)="chooseSingleOption(option)">
                <span class="faded">
                  {{ option.label }}
                </span>
              </div>
              <mat-divider
                class="single-opt-divider"
                *ngIf="selectedDividerPosition === i && filteredFilterByOptions?.length > 2"></mat-divider>
            </ng-container>
          </ng-container>
        </div>
        <!-- </ng-container> -->
        <ng-template #somethingWentWrong>
          <span class="display-flex justify-content-center notification notification-error">
            Something went wrong. Give it another try!
          </span>
        </ng-template>
      </ng-container>
    </ng-container>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="display-flex align-items-center justify-content-space-between grid-gap-16">
  <span class="summary-filter-by-actions-text display-flex align-items-center grid-gap-10">
    <span *ngIf="isLoading">Counting...</span>
    <span *ngIf="!isLoading">
      <ng-container *ngIf="allSelected || selectedCount === 0">Filter not set</ng-container>
      <ng-container *ngIf="!allSelected && selectedCount > 0">
        {{ selectedCount }} {{ selectedCount === 1 ? 'item' : 'items' }} selected
      </ng-container>
    </span>
    <div class="summary-filter-by-actions-divider"></div>
    <a class="summary-filter-by-click summary-filter-by-click-action" (click)="resetFilters()">Reset filter</a>
  </span>
  <button
    *ngIf="isMultiselect"
    class="summary-filter-by-modal-button"
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="isSaving">
    <div class="display-flex align-items-center grid-gap-8">
      <mat-progress-spinner *ngIf="isSaving" diameter="30" color="primary" mode="indeterminate"></mat-progress-spinner>
      <span>Close</span>
    </div>
  </button>

  <button
    *ngIf="!isMultiselect"
    class="summary-filter-by-modal-button"
    mat-stroked-button
    color="warn"
    (click)="cancel()">
    <span>Cancel</span>
  </button>
</mat-dialog-actions>

<ng-template #loading>
  <div class="filter-by-loading display-flex align-items-center justify-content-center">
    <mat-progress-spinner diameter="64" color="primary" mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>

<ng-template #filterByOptionsEmpty>
  <div class="filter-by-loading display-flex flex-column align-items-center justify-content-center grid-gap-12">
    <img src="/assets/no-results-found.svg" width="120" height="107" />
    <div class="display-flex flex-column align-items-center justify-content-center grid-gap-4">
      <span>No results found</span>
      <span *ngIf="form.get('searchBase')?.value === BaseType.Report">
        Try switching to
        <a class="summary-filter-by-click" (click)="toggleSearchBase()">all {{ filterName || '' }} values</a>
        to see more options
      </span>
    </div>
  </div>
</ng-template>
